import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
// import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ViewConsumption from './ViewConsumption';
import Header from '../../models/Header';
import { makeStyles } from '@material-ui/core/styles';
import UpdateBMRData from '../../batch/updateBatch/BMRConsumption/UpdateBMRData';
import ViewBatchDetails from '../../batch/ViewRMPMLots/index';
import axios from 'axios';
import { appUrl } from '../../../../../../../utils/config';

export const useStyles = makeStyles((theme) => ({
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const Index = (props) => {
  const classes = useStyles();
  const {targetQuantity, schrockenDeliveryScheduleID, schrockenDeliveryScheduleBatchID, bomConsumptionAddedIndicator, files} = props
  const [openSADetails, setOpenSADetails] = useState(false);
  const [batchData, setBatchData] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const handleCloseSA = () => {
    setOpenSADetails(false);
    setBatchData(null); // Reset batch data when closing
  };

  const fetchDeliveryScheduleBatchDetails = async () => {
    if (!schrockenDeliveryScheduleBatchID) {
      console.error("schrockenDeliveryScheduleBatchID is required");
      return;
    }

    setLoading(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`;
      const payload = {
        schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
        //cmoBatchNumber: props.batchRowData.cmoBatchNumber,
      };

      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        const originalBatchData = response.data.data;
        // Override with dashboard API data for header fields if available from batch dashboard
        const manipulatedBatchData = props.batchRowData ? {
          ...originalBatchData,
          // Header fields to prioritize from dashboard APIs
          vendorBatchNumber: props.batchRowData.vendorBatchNumber,
          sponsorOrgName: props.batchRowData.brandOwnerName,
          brandOwnerName: props.batchRowData.brandOwnerName,
          vendorName: props.batchRowData.vendorName,
          // cmoMember: props.batchRowData.vendorName || props.batchRowData.cmoMember || originalBatchData.cmoMember,
          fgMaterialCode: props.batchRowData.fgMaterialCode,
          fgMaterialName: props.batchRowData.fgMaterialName,
          scheduleAgreementNumber: props.batchRowData.scheduleAgreementNumber,
          batchSize: props.batchRowData.batchSize,
          batchUOM: props.batchRowData.batchUOM,
          manufacturingDate: originalBatchData?.manufacturingDate,
          grnGeneratedDate: originalBatchData?.grnGeneratedDate,
          poFulfilment: originalBatchData?.poFulfilment,
          dateOfReceipt: originalBatchData?.dateOfReceipt,
          vendorPlant: originalBatchData?.vendorPlant || props.batchRowData.vendorPlant,
        } : originalBatchData;
        
        setBatchData(manipulatedBatchData);
        setOpenSADetails(true); // Open dialog after successful API call
      } else {
        console.error("API returned error status:", response.data);
      }
    } catch (error) {
      console.error("Error fetching delivery schedule batch details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleIconClick = () => {
    fetchDeliveryScheduleBatchDetails();
  };

  const getLatestFile = (files) => {
    if (!files || files.length === 0) return null; // Handle empty array
    return files.reduce((latest, current) => {
        return new Date(current.lastUpdatedDate) > new Date(latest.lastUpdatedDate) ? current : latest;
    });
  };
  
  let bmrFile = files && Array.isArray(files) ? files : []

  // console.log(bmrFile)
  let latestFile = getLatestFile(bmrFile);

  
  return (
    <React.Fragment>
      <DynamicFeedIcon
        fontSize='small'
        className={classes.multipleLogo}
        onClick={handleIconClick}
        style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'wait' : 'pointer' }}
      />

      {/* {openSADetails &&
      <UpdateBMRData
      {...props}
      open={openSADetails}
      onClose={handleCloseSA}
    handleClose={handleCloseSA}
schrockenCustomFileID={latestFile ? latestFile.schrockenCustomFileID : ''}
batchDetails={{
  schrockenDeliveryScheduleID: schrockenDeliveryScheduleID,
  schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
  bomConsumptionAddedIndicator: bomConsumptionAddedIndicator,
}}
targetQuantity={targetQuantity}
viewFlag={true}
    />
      } */}

      {openSADetails && batchData &&
      <Dialog
        fullScreen
        open={openSADetails}
        onClose={handleCloseSA}
        TransitionComponent={Transition}
      >
        <Header
          handleClose={handleCloseSA}
          title='Batch Details'
          padding={true}
        >
          <ViewBatchDetails
            selectedDeliveryBatchID={schrockenDeliveryScheduleBatchID}
            targetQuantity={targetQuantity}
            batchDetails={{
              ...batchData,
              schrockenDeliveryScheduleID: schrockenDeliveryScheduleID,
              schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
              bomConsumptionAddedIndicator: bomConsumptionAddedIndicator,
              vendorPlantID: batchData?.vendorPlant,
              // storageLocation: batchData?.storageLocation,
              ...props
            }}
            showRMPMDetails={true}
            row={props}
            dashboardViewConsumption = {true}
            batchRowData={props.batchRowData}
            cmoBatchNumber={props.batchRowData.cmoBatchNumber}
          />
        </Header>
      </Dialog>
      }
      
      {/* <Dialog
        fullScreen
        open={openSADetails}
        onClose={handleCloseSA}
        TransitionComponent={Transition}
      >
        <Header
          handleClose={handleCloseSA}
          title='Consumption Information'
          padding={true}
        >
          <ViewConsumption handleClose={handleCloseSA} {...props} />
        </Header>
      </Dialog> */}
    </React.Fragment>
  );
};

export default Index;
